var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmergeBatchAvatarBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3581_172",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -16,
    y: -2,
    width: 61,
    height: 34
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -15.6,
    y: -1.96191,
    width: 60.6,
    height: 33.9237,
    fill: "#5A31F4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3581_172)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -15.6,
    y: -1.96338,
    width: 60.6,
    height: 33.9237,
    fill: "#E6E7EE"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_3581_172)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.1528,
    cy: 27.7497,
    rx: 24.0064,
    ry: 22.3809,
    transform: "rotate(-0.942142 41.1528 27.7497)",
    fill: "url(#paint0_linear_3581_172)",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_3581_172)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: -14.2122,
    cy: 6.79736,
    rx: 28.4693,
    ry: 22.4804,
    transform: "rotate(-0.942142 -14.2122 6.79736)",
    fill: "#EFEAFE",
    fillOpacity: 0.95
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3581_172",
    x: -4.44106,
    y: -16.2194,
    width: 91.1877,
    height: 87.9383,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.7939,
    result: "effect1_foregroundBlur_3581_172"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_3581_172",
    x: -51.1611,
    y: -24.166,
    width: 73.8977,
    height: 61.9267,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.24046,
    result: "effect1_foregroundBlur_3581_172"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3581_172",
    x1: 38.8097,
    y1: 22.2193,
    x2: -13.7969,
    y2: 21.3405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#11E8C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11E8C2",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmergeBatchAvatarBackground);
export default __webpack_public_path__ + "static/media/EmergeBatchAvatarBackground.c873ed8ea912762287e2a2885fb81084.svg";
export { ForwardRef as ReactComponent };